import React, { useMemo, useState } from 'react';
import { Button, ToggleButtonGroup } from '@pinwheel/origami';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../state';
import { selectIncomeSources, setIncomeSourceW2, } from '../../state/slices/slice-wizard';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import BaseWizardScreen from './BaseWizardScreen';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var W2_INCOME_SOURCE_COUNT_OPTIONS = [
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3+', label: '3+' },
];
export default function WizardIncomeSourceW2() {
    var incomeSources = useAppSelector(selectIncomeSources);
    var navigate = useLinkNavigate();
    var dispatch = useDispatch();
    var getLocalizedString = useGetLocalizedString();
    var _a = useState(W2_INCOME_SOURCE_COUNT_OPTIONS[0]), selectedCount = _a[0], setSelectedCount = _a[1];
    var determineRoute = useMemo(function () {
        if (incomeSources.incomeSources.find(function (is) { return is === '1099'; })) {
            return '/wizard/income-source-1099';
        }
        if (incomeSources.incomeSources.find(function (is) { return is === 'benefits'; })) {
            return '/wizard/income-source-benefits';
        }
        return '/search/search';
    }, [incomeSources]);
    var button = useMemo(function () { return (React.createElement(Button, { dataTestId: "Continue", onClick: function () {
            dispatch(setIncomeSourceW2({
                visited: true,
                numberOfJobs: selectedCount.value,
            }));
            return navigate(determineRoute);
        } }, getLocalizedString('CONTINUE'))); }, [selectedCount, determineRoute, navigate, getLocalizedString, dispatch]);
    var body = useMemo(function () { return (React.createElement(ToggleButtonGroup, { options: W2_INCOME_SOURCE_COUNT_OPTIONS, value: selectedCount, onChange: setSelectedCount })); }, [selectedCount]);
    return (React.createElement(BaseWizardScreen, { dataTestId: "Wizard-IncomeSourceW2", titleText: getLocalizedString('WIZARD_INCOME_SOURCE_W2'), buttons: button }, body));
}
